/**

 * Ads LP iron — Servicify calendar parity.

 * LP product IDs are absent from Servicify settings.productIds; shim to canonical iron

 * products for embed init, rewrite event API variant IDs, remap cart to LP variants.

 */

(function () {

  var CANON_HANDLE = {

    'lp-iron-therapy': 'iron-therapy',

    'lp-iron-therapy-texas': 'iron-therapy-texas',

    'lp-iron-therapy-new-jersey': 'iron-therapy-new-jersey',

    'lp-iron-therapy-georgia': 'iron-therapy-georgia',

    'lp-iron-therapy-florida': 'iron-therapy-florida',

  };



  var MOBILE_BY_HANDLE = {

    'lp-iron-therapy': 'Mobile Services - All of New York City and Long Island',

    'lp-iron-therapy-texas': 'Mobile Services - Texas',

    'lp-iron-therapy-new-jersey': 'Mobile Services - New Jersey',

    'lp-iron-therapy-georgia': 'Mobile Services - Georgia',

    'lp-iron-therapy-florida': 'Mobile Services - Florida',

  };



  /** @type {Record<string, string>} LP variant → canonical (for early Servicify XHR) */

  var STATIC_LP_TO_CANON_VARIANT = {

    '67605717549129': '40881262657609',

    '67605717581897': '41867145183305',

    '67605717614665': '40881262690377',

    '67605717647433': '41867145216073',

    '67605717680201': '40881262723145',

    '67605717712969': '41867145248841',

    '67605717778505': '55901057351753',

    '67605717811273': '55901057384521',

    '67605717909577': '55636655013961',

    '67605717942345': '55904809615433',

    '67605718040649': '56088396726345',

    '67605718073417': '56088396759113',

    '67605718138953': '56083616825417',

    '67605718171721': '56083616858185',

  };



  var STATIC_LP_TO_CANON_PRODUCT = {

    '15828885700681': '6987982110793',

    '15828885766217': '15655261995081',

    '15828885798985': '15525854314569',

    '15828885864521': '15784240250953',

    '15828885962825': '15782472613961',

  };



  var canonProductJs = null;

  var canonToLpVariant = {};

  var lpToCanonVariant = {};

  var servicifyShimInstalled = false;



  function canonVariantForLp(lpVariantId) {

    var key = String(lpVariantId);

    if (lpToCanonVariant[key]) return String(lpToCanonVariant[key]);

    if (STATIC_LP_TO_CANON_VARIANT[key]) return STATIC_LP_TO_CANON_VARIANT[key];

    return key;

  }



  function rewriteServicifyApiUrl(url) {

    if (!url || url.indexOf('servicify-appointments.herokuapp.com/api/products/') === -1) return url;

    try {

      var u = new URL(url, window.location.origin);

      var parts = u.pathname.split('/');

      var idx = parts.indexOf('products');

      if (idx === -1 || !parts[idx + 1]) return url;

      var pid = parts[idx + 1];

      if (STATIC_LP_TO_CANON_PRODUCT[pid]) parts[idx + 1] = STATIC_LP_TO_CANON_PRODUCT[pid];

      u.pathname = parts.join('/');

      var vid = u.searchParams.get('variantId');

      if (vid && vid !== 'undefined') {

        u.searchParams.set('variantId', canonVariantForLp(vid));

      }

      return u.toString();

    } catch (e) {

      return url;

    }

  }



  (function installServicifyApiRewrite() {

    if (window.__dgAdsLpServicifyApiRewrite) return;

    window.__dgAdsLpServicifyApiRewrite = true;



    var origFetch = window.fetch;

    if (origFetch) {

      window.fetch = function (input, init) {

        var url = typeof input === 'string' ? input : input && input.url;

        var next = rewriteServicifyApiUrl(url);

        if (next !== url) {

          input = typeof input === 'string' ? next : new Request(next, input);

        }

        return origFetch.call(this, input, init);

      };

    }



    var origOpen = XMLHttpRequest.prototype.open;

    XMLHttpRequest.prototype.open = function (method, url) {

      var args = arguments;

      if (typeof url === 'string') args[1] = rewriteServicifyApiUrl(url);

      return origOpen.apply(this, args);

    };

  })();



  function isAdsLpPage() {

    return /\/products\/(lp-iron-therapy(?:-[a-z-]+)?)\/?$/.test(window.location.pathname);

  }



  function lpHandle() {

    var m = window.location.pathname.match(/\/products\/(lp-iron-therapy(?:-[a-z-]+)?)/);

    return m ? m[1] : '';

  }



  function mobileValue() {

    return MOBILE_BY_HANDLE[lpHandle()] || '';

  }



  function metaProduct() {

    return window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;

  }



  function priceCentsFromJs(v) {

    if (typeof v.price === 'number') return Math.round(v.price);

    var n = parseFloat(String(v.price || '0').replace(/,/g, ''));

    return Math.round(n * 100);

  }



  function buildVariantMaps(lpMeta, canonJs) {

    canonToLpVariant = {};

    lpToCanonVariant = {};

    (canonJs.variants || []).forEach(function (cv) {

      var lp = (lpMeta.variants || []).find(function (lv) {

        return lv.public_title === cv.title || lv.title === cv.title || lv.name === cv.name;

      });

      if (lp) {

        canonToLpVariant[String(cv.id)] = Number(lp.id);

        lpToCanonVariant[String(lp.id)] = Number(cv.id);

      }

    });

  }



  function canonVariantsForServicify(canonJs) {

    return (canonJs.variants || []).map(function (v) {

      return {

        id: v.id,

        title: v.title,

        name: canonJs.title + ' - ' + v.title,

        public_title: v.title,

        options: [v.option1, v.option2, v.option3].filter(Boolean),

        price: priceCentsFromJs(v),

        available: v.available !== false,

        requires_shipping: v.requires_shipping,

      };

    });

  }



  function applyServicifyShim(canonJs) {

    var lp = metaProduct();

    if (!lp || !canonJs) return;



    if (!lp.__dgAdsLpVariants) {
      lp.__dgAdsLpVariants = (lp.variants || []).slice();
    }

    buildVariantMaps({ variants: lp.__dgAdsLpVariants }, canonJs);



    var view = {

      id: Number(canonJs.id),

      gid: lp.gid,

      handle: canonJs.handle,

      title: canonJs.title,

      vendor: canonJs.vendor,

      type: lp.type,

      variants: canonVariantsForServicify(canonJs),

      images: lp.images,

      featured_image: lp.featured_image,

      options: lp.options,

      price: lp.price,

      price_min: lp.price_min,

      price_max: lp.price_max,

      available: lp.available,

    };



    if (!lp.__dgAdsLpOriginalId) lp.__dgAdsLpOriginalId = lp.id;

    Object.assign(lp, view);

    patchServicifyProductFromMeta();

    servicifyShimInstalled = true;

  }



  function patchServicifyProductFromMeta() {

    var lp = metaProduct();

    if (!lp || !window.SERVICIFY_PRODUCT) return;

    Object.assign(window.SERVICIFY_PRODUCT, lp);

  }



  function installServicifyProductGuard() {

    if (window.__dgAdsLpServicifyGuard) return;

    window.__dgAdsLpServicifyGuard = true;

    var tick = function () {

      if (servicifyShimInstalled) patchServicifyProductFromMeta();

    };

    setInterval(tick, 250);

    try {

      var obs = new MutationObserver(tick);

      obs.observe(document.documentElement, { childList: true, subtree: true });

    } catch (e) {}

  }



  function loadCanonAndShim() {

    var handle = lpHandle();

    var canonHandle = CANON_HANDLE[handle];

    var lp = metaProduct();

    if (!canonHandle || !lp || lp.handle !== handle) return;



    if (canonProductJs && canonProductJs.handle === canonHandle) {

      applyServicifyShim(canonProductJs);

      return;

    }



    fetch('/products/' + canonHandle + '.js')

      .then(function (r) {

        return r.json();

      })

      .then(function (json) {

        canonProductJs = json;

        applyServicifyShim(json);

      })

      .catch(function () {});

  }



  function remapVariantInBody(body) {

    if (!body) return body;

    try {

      var data = typeof body === 'string' ? JSON.parse(body) : body;

      var id = data.id != null ? String(data.id) : null;

      if (!id) return body;

      if (canonToLpVariant[id]) {

        data.id = canonToLpVariant[id];

      } else {

        for (var lpId in STATIC_LP_TO_CANON_VARIANT) {

          if (STATIC_LP_TO_CANON_VARIANT[lpId] === id) {

            data.id = Number(lpId);

            break;

          }

        }

      }

      return typeof body === 'string' ? JSON.stringify(data) : data;

    } catch (e) {}

    return body;

  }



  function installCartRemap() {

    if (window.__dgAdsLpCartRemap) return;

    window.__dgAdsLpCartRemap = true;



    var origFetch = window.fetch;

    if (origFetch) {

      window.fetch = function (input, init) {

        init = init || {};

        var url = typeof input === 'string' ? input : input && input.url;

        if (url && /\/cart\/add(\.js)?/.test(url) && init.body) {

          init = Object.assign({}, init, { body: remapVariantInBody(init.body) });

        }

        var responsePromise = origFetch.call(this, input, init);
        if (lpHandle() === 'lp-iron-therapy' && url && /\/cart\/add(\.js)?/.test(url)) {
          Promise.resolve(responsePromise).then(function (response) {
            if (response && response.ok) {
              document.dispatchEvent(new Event('dg-ads:reattach'));
            }
          }, function () {});
        }
        return responsePromise;

      };

    }



    var origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.send = function (body) {

      if (this.__dgUrl && /\/cart\/add(\.js)?/.test(this.__dgUrl) && body) {

        body = remapVariantInBody(body);

      }

      if (lpHandle() === 'lp-iron-therapy' && this.__dgUrl && /\/cart\/add(\.js)?/.test(this.__dgUrl)) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) {
            document.dispatchEvent(new Event('dg-ads:reattach'));
          }
        }, { once: true });
      }
      return origSend.call(this, body);

    };



    var origXOpen = XMLHttpRequest.prototype.open;

    XMLHttpRequest.prototype.open = function (method, url) {

      this.__dgUrl = url;

      if (typeof url === 'string') {

        arguments[1] = rewriteServicifyApiUrl(url);

      }

      return origXOpen.apply(this, arguments);

    };

  }



  function productRoot() {

    return (

      document.querySelector('#custom__product-variant-desk') ||

      document.querySelector('.featured-product')

    );

  }



  var heroBookingSeq = 0;

  var lastSyncKey = null;

  var lastSyncAt = 0;

  function servicifyCalendarOpen() {
    if (document.body.classList.contains('ReactModal__Body--open')) return true;

    var portals = document.querySelectorAll('.ReactModalPortal .ReactModal__Content');

    for (var i = 0; i < portals.length; i++) {
      if (portals[i].offsetParent !== null) return true;
    }

    return false;
  }

  // Ads LP safety guard: Servicify can occasionally resolve the correct event
  // without mounting its calendar after a native Book Now click (observed most
  // often on multi-location NYC package variants). Do not replace or block the
  // native click. Only retry it if no calendar is visible after a settle window.
  var nativeBookingRetrySeq = 0;

  function currentEasyAppointmentButton() {
    var btn =
      document.querySelector('#custom__product-variant-desk .easy_appointment_custom') ||
      document.querySelector('.featured-product .easy_appointment_custom') ||
      document.querySelector('button.easy_appointment_custom');

    if (btn && btn.offsetParent === null) btn = null;
    return btn;
  }

  function retryNativeBookingIfNeeded(seq, attempt) {
    if (seq !== nativeBookingRetrySeq) return;
    if (servicifyCalendarOpen()) return;
    if (attempt >= 2) return;

    var btn = currentEasyAppointmentButton();
    if (!btn) return;

    // Programmatic .click() is intentionally not intercepted by the trusted-click
    // listener below, so each recovery attempt schedules no additional loop.
    btn.click();

    setTimeout(function () {
      retryNativeBookingIfNeeded(seq, attempt + 1);
    }, 3000);
  }

  function installNativeBookingRetryGuard() {
    if (window.__dgAdsLpNativeBookingRetryGuard) return;
    window.__dgAdsLpNativeBookingRetryGuard = true;

    document.addEventListener(
      'click',
      function (e) {
        if (!isAdsLpPage() || !e.isTrusted) return;

        var target = e.target && e.target.closest
          ? e.target.closest('button.easy_appointment_custom')
          : null;
        if (!target) return;

        var root = productRoot();
        if (root && !root.contains(target)) return;

        var seq = ++nativeBookingRetrySeq;

        // Normal opens complete well before this. Recovery only starts when the
        // native click has genuinely failed to mount a calendar.
        setTimeout(function () {
          retryNativeBookingIfNeeded(seq, 0);
        }, 3000);
      },
      false,
    );
  }


  function openServicifyBooking(retry, seq) {

    retry = retry || 0;

    if (seq == null) seq = ++heroBookingSeq;

    if (seq !== heroBookingSeq) return false;

    if (servicifyCalendarOpen()) return true;

    var eaBtn =

      document.querySelector('#custom__product-variant-desk .easy_appointment_custom') ||

      document.querySelector('.featured-product .easy_appointment_custom') ||

      document.querySelector('button.easy_appointment_custom');

    if (eaBtn && eaBtn.offsetParent === null) eaBtn = null;

    if (!eaBtn) {
      if (retry < 60) {
        setTimeout(function () {
          openServicifyBooking(retry + 1, seq);
        }, 200);
      }

      return false;
    }

    eaBtn.click();

    if (servicifyCalendarOpen()) return true;

    if (retry < 10) {
      setTimeout(function () {
        if (seq !== heroBookingSeq) return;

        if (servicifyCalendarOpen()) return;

        syncServicifyVariant();

        setTimeout(function () {
          openServicifyBooking(retry + 1, seq);
        }, 300);
      }, 700);
    }

    return true;

  }



  function syncServicifyVariant(variantId) {
    var root = productRoot();
    if (!variantId && root) {
      var idInput = root.querySelector('[name="id"]');
      variantId = idInput && idInput.value;
    }
    var canonVariantId = variantId && canonVariantForLp(variantId);
    if (canonVariantId) {
      var syncKey = String(canonVariantId) + ':' + (canonProductJs ? canonProductJs.id : '');
      var now = Date.now();
      if (syncKey === lastSyncKey && now - lastSyncAt < 5000) return;
      lastSyncKey = syncKey;
      lastSyncAt = now;
      document.dispatchEvent(
        new CustomEvent('servicify-variant-change', {
          detail: {
            variantId: Number(canonVariantId),
            productId: canonProductJs ? Number(canonProductJs.id) : undefined,
          },
        }),
      );
    }
  }

  function syncMobileSingle() {
    var root = productRoot();
    var mobile = mobileValue();
    if (!root || !mobile) return;
    var esc = mobile.replace(/"/g, '\\"');
    var loc = root.querySelector('input[type="radio"][value="' + esc + '"]');
    if (loc && !loc.checked) {
      loc.checked = true;
      loc.dispatchEvent(new Event('change', { bubbles: true }));
    }
    syncServicifyVariant();
  }



  function startHeroBookingFlow() {

    // Ads hero CTA only scrolls to the existing product booking section.
    // The actual Book Now button remains responsible for opening Servicify.
    heroBookingSeq++;

    var target = document.querySelector('.shopify-section.featured-product') || productRoot();
    if (!target) return;

    var header = document.querySelector('.site-header') || document.querySelector('#SiteHeader');
    var headerOffset = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? 'auto' : 'smooth' });

  }



  function interceptHeroCartBypass() {

    if (window.__dgAdsLpHeroIntercept) return;

    window.__dgAdsLpHeroIntercept = true;

    document.addEventListener(

      'click',

      function (e) {

        if (!isAdsLpPage()) return;

        var bookBtn = e.target.closest('[data-test-book-btn]');

        if (!bookBtn || bookBtn.closest('.featured-product, #custom__product-variant-desk')) return;

        e.preventDefault();

        e.stopImmediatePropagation();

        startHeroBookingFlow();

      },

      true,

    );

    document.querySelectorAll('.test-modal [name="add"].add-to-cart').forEach(function (btn) {

      btn.addEventListener(

        'click',

        function (e) {

          if (!isAdsLpPage()) return;

          e.preventDefault();

          e.stopImmediatePropagation();

          startHeroBookingFlow();

        },

        true,

      );

    });



    document.querySelectorAll('form.product-single__form_shop_all').forEach(function (form) {

      form.addEventListener(

        'submit',

        function (e) {

          if (!isAdsLpPage()) return;

          var sub = e.submitter;

          if (sub && sub.name === 'add' && sub.closest('.test-modal, .slideshow__slide')) {

            e.preventDefault();

            e.stopImmediatePropagation();

            startHeroBookingFlow();

          }

        },

        true,

      );

    });

  }



  function guardProductAddToCart() {

    var root = productRoot();

    if (!root) return;

    root.querySelectorAll('button[name="add"].add-to-cart').forEach(function (btn) {

      if (btn.classList.contains('easy_appointment_custom')) return;

      btn.addEventListener(

        'click',

        function (e) {

          if (!isAdsLpPage()) return;

          if (document.querySelector('.easy_appointment_custom')) {

            e.preventDefault();

            e.stopImmediatePropagation();

            syncServicifyVariant();

            openServicifyBooking(0);

          }

        },

        true,

      );

    });

  }



  function waitForMetaAndShim() {

    if (!isAdsLpPage()) return;

    installCartRemap();

    installServicifyProductGuard();

    loadCanonAndShim();

  }



  function boot() {

    if (!isAdsLpPage()) return;

    interceptHeroCartBypass();

    installNativeBookingRetryGuard();

    guardProductAddToCart();

    // NYC is multi-location: honor the first available location, like main Iron Therapy.
    // Other Ads LPs remain Mobile-only.
    if (lpHandle() !== 'lp-iron-therapy') syncMobileSingle();

  }



  if (isAdsLpPage()) {

    interceptHeroCartBypass();

    installNativeBookingRetryGuard();

    var metaPoll = setInterval(function () {

      var lp = metaProduct();

      if (lp && lp.handle === lpHandle()) {

        waitForMetaAndShim();

      }

    }, 0);

    setTimeout(function () {

      clearInterval(metaPoll);

    }, 15000);

  }



  document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('page:loaded', boot);

  document.addEventListener('variant:change', function (event) {

    if (!isAdsLpPage()) return;

    var variantId = event && event.detail && event.detail.variant && event.detail.variant.id;

    syncServicifyVariant(variantId);

    setTimeout(guardProductAddToCart, 400);

  });

})();


